import { render, staticRenderFns } from "./PurchasePaymentCreateView.vue?vue&type=template&id=1a8a33a7"
import script from "./PurchasePaymentCreateView.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports